import { Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import { CardTitle } from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { Input } from "../../components/ui/input";
import {
  API,
  cddOptions,
  fileUpload,
  get,
  riskProfile,
  verificationMethods,
} from "../../config";
import { PhoneInput } from "../../components/ui/phone-input";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";
import SearchSelect from "../../components/SearchSelect";
import { SuburbList, useBankList, useStateList } from "../../lib/OptionsAPI";
import { Download, FileIcon, Loader2 } from "lucide-react";
import PostalCodeInput from "../../components/PostalCodeInput";
import { Checkbox } from "../../components/ui/checkbox";
import { NumericFormat } from "react-number-format";
import {
  formatBSBNumber,
  formatSubcontractorName,
  getFileNameFromUrl,
  getModuleNamingBySlug,
  MaxLimit,
} from "../../lib/Misc";
import { Button } from "../../components/ui/button";
import VendorSelect from "../../components/VendorSelect";
import { useOrganization } from "../../lib/context/OrganisationContext";
import moment from "moment";
import { Textarea } from "../../components/ui/textarea";
import UserSelect from "../../components/UserSelect";
import { DateInputPicker } from "../../components/DateInputPicker";
import Dropzone from "react-dropzone";
import ProfileUpload from "../../components/ProfileUpload";
import { toast } from "../../components/ui/use-toast";
import { AddBeneficarySchema } from "../../lib/Validation";
import SuburbSelect from "../../components/SuburbSelect";
import TrustSelect from "../../components/TrustSelect";
import ContactSelect from "../../components/ContactSelect";

const AddEditBeneficary = ({
  id,
  toggleShowAddEditBeneficary,
  edit,
  fetchBeneficaryData,
  trustId,
  org = false,
  amlCTFEnable = false,
}) => {
  const [beneficaryData, setBeneficaryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [suburbShippingLoading, setSuburbShippingLoading] = useState(false);
  const [suburbShippingListing, setSuburbShippingListing] = useState([]);
  const [suburbShippingList, setSuburbShippingList] = useState([]);

  const [trustLoading, setTrustLoading] = useState(false);
  const [trustListing, setTrustListing] = useState([]);
  const [trustList, setTrustList] = useState([]);

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  const [primaryID, setPrimaryID] = useState([]);
  const [secondaryID, setSecondaryID] = useState([]);

  const { organizationData } = useOrganization();

  const contactTypeOption = [
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "vendors",
        "Vendor",
      )}`,
      value: 1,
    },
    {
      label: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer",
      )}`,
      value: 2,
    },
  ];

  const toggleChecked = (values, setFieldValue) => {
    setIsChecked(!isChecked);
    if (isChecked === false) {
      setFieldValue("shipping_street", values?.street);
      setFieldValue("shipping_state_id", values?.state_id);
      setFieldValue("shipping_suburb_id", values?.suburb_id);
      setFieldValue("shipping_postal_code", values?.postal_code);
      setSuburbShippingListing([
        suburbListing?.find((item) => item.value === values?.suburb_id),
      ]);
    } else {
      setFieldValue("shipping_street", "");
      setFieldValue("shipping_state_id", "");
      setFieldValue("shipping_suburb_id", "");
      //   dispatch(shippingSuburbsList("", ""));
      setSuburbShippingListing([]);
      setSuburbShippingList([]);
      setFieldValue("shipping_postal_code", "");
    }
  };

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  const FetchSuburbShippingList = async (state_id) => {
    await SuburbList(
      state_id,
      1,
      setSuburbShippingLoading,
      setSuburbShippingList,
      true,
    );
  };

  useEffect(() => {
    if (suburbShippingList) {
      let suburbShippingTempListing = suburbShippingList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbShippingListing(suburbShippingTempListing || []);
    } else {
      setSuburbShippingListing([]);
    }
  }, [suburbShippingList]);

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  async function fetchData() {
    try {
      setLoading(true);
      const reponse = await get(`${API.BENEFICARY_DETAILS}/` + id);

      setBeneficaryData(reponse?.data?.data);
      let data = reponse?.data?.data;
      if (data?.same_address) {
        setIsChecked(true);
      } else {
        setIsChecked(false);
      }
      if (data?.state_id ? data?.state_id : false) {
        FetchSuburbList(data?.state_id ? data?.state_id : "", "");
        if (data?.suburb_id ? data?.suburb_id : false) {
          setSuburbList([
            data?.suburb
              ? {
                  ...data?.suburb,
                  value: data?.suburb.id,
                  label: data?.suburb.name,
                }
              : {},
          ]);
        }
      }
      if (data?.shipping_state_id ? data?.shipping_state_id : false) {
        FetchSuburbShippingList(
          data?.shipping_state_id ? data?.shipping_state_id : "",
          "",
        );
        if (data?.shipping_suburb_id ? data?.shipping_suburb_id : false) {
          setSuburbShippingList([
            data?.shipping_suburb
              ? {
                  ...data?.shipping_suburb,
                  value: data?.shipping_suburb.id,
                  label: data?.shipping_suburb.name,
                }
              : {},
          ]);
        }
      }
      setLoading(false);
    } catch (e) {
      setBeneficaryData(null);
    }
  }
  useEffect(() => {
    if (edit) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // State
  const { stateLoading, stateList = [] } = useStateList();
  const stateListing = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });
  const state = stateListing?.find(
    (item) =>
      item?.value ===
      (beneficaryData?.state_id ? beneficaryData?.state_id : ""),
  )?.value;

  // ShippingState
  const shippingStateListing = stateList?.map((item) => {
    const { name: label, id: value, ...rest } = item;
    return { label, value, ...rest };
  });
  const shippingState = shippingStateListing?.find(
    (item) =>
      item?.value ===
      (beneficaryData?.shipping_state_id
        ? beneficaryData?.shipping_state_id
        : ""),
  )?.value;

  // Bank
  const { bankLoading, bankList = [] } = useBankList();
  const bankListing = bankList ? bankList : [];
  const projectBank = bankListing?.find(
    (item) => item?.value === beneficaryData?.bank_id,
  )?.value;

  useEffect(() => {
    if (trustList) {
      let trustTempListing = trustList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${
          item?.business_name
            ? item?.business_name
            : item?.first_name
              ? item?.first_name + " " + item?.last_name
              : item?.last_name
        } ${item?.account_number ? `(${item?.account_number})` : ""}`,
      }));
      let finalList = trustTempListing?.filter(
        (item) => item?.id !== trustId && item?.id !== "new",
      );
      setTrustListing(finalList || []);
    } else {
      setTrustListing([]);
    }
  }, [trustList, trustId]);

  const handleFormSubmit = async (value, { setErrors, resetForm }) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.mobile = value?.mobile ? `${value?.mobile}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    formData.append(
      "organization_id",
      organizationData?.organizationId ? organizationData?.organizationId : "",
    );
    if (org && value?.trust_id ? value?.trust_id : trustId) {
      formData.append(
        "trust_id",
        org && value?.trust_id ? value?.trust_id : trustId ? trustId : "",
      );
    }

    formData.append(
      "contactable_id",
      value?.contactable_id ? value?.contactable_id : "",
    );
    formData.append("vendor_id", value?.vendor_id ? value?.vendor_id : "");
    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("mobile", value?.mobile ? value?.mobile : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : "",
    );
    formData.append("abn", value?.abn ? value?.abn : "");
    formData.append(
      "license_number",
      value?.license_number ? value?.license_number : "",
    );
    formData.append("code", value?.code ? value?.code : "");

    formData.append(
      "percentage",
      value?.percentage ? value?.percentage?.toString()?.replace("%", "") : "",
    );
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", value?.state_id ? value?.state_id : "");
    formData.append("suburb_id", value?.suburb_id ? value?.suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : "",
    );
    formData.append("same_address", isChecked ? 1 : 0);
    formData.append(
      "shipping_street",
      value?.shipping_street ? value?.shipping_street : "",
    );
    formData.append(
      "shipping_state_id",
      value?.shipping_state_id ? value?.shipping_state_id : "",
    );
    formData.append(
      "shipping_suburb_id",
      value?.shipping_suburb_id ? value?.shipping_suburb_id : "",
    );
    formData.append(
      "shipping_postal_code",
      value?.shipping_postal_code ? value?.shipping_postal_code : "",
    );
    formData.append(
      "account_name",
      value?.account_name ? value?.account_name : "",
    );
    formData.append("bsb", value?.bsb ? formatBSBNumber(value?.bsb) : "");
    formData.append(
      "account_number",
      value?.account_number ? value?.account_number : "",
    );
    formData.append(
      "opening_balance",
      value?.opening_balance ? value?.opening_balance : 0,
    );
    formData.append("bank_id", value?.bank_id ? value?.bank_id : "");

    formData.append("photo_id", value?.photo_id ? value?.photo_id : "");
    formData.append("primary_id", value?.primary_id ? value?.primary_id : "");
    formData.append(
      "secondary_id",
      value?.secondary_id ? value?.secondary_id : "",
    );
    formData.append(
      "verification_date",
      value?.verification_date
        ? moment(value?.verification_date)?.format("DD-MM-YYYY")
        : "",
    );
    formData.append(
      "verified_by",
      value?.verified_by ? value?.verified_by : "",
    );
    formData.append("method", value?.method ? value?.method : "");
    formData.append("risk", value?.risk ? value?.risk : "");
    formData.append("cdd", value?.cdd ? value?.cdd : "");
    formData.append("notes", value?.notes ? value?.notes : "");

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.BENEFICARY_ADD}${edit ? `/${id}` : ""}`,
        formData,
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditBeneficary();
        fetchBeneficaryData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  const handleDownload = async (export_report_path) => {
    try {
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "file.pdf");
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      toast({
        variant: "destructive",
        description: errors,
        duration: 3000,
      });
    }
  };

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  return (
    <Formik
      initialValues={{
        trust_id: beneficaryData?.trust_id
          ? beneficaryData?.trust_id
          : trustId
            ? trustId
            : "",
        contactable_id: beneficaryData?.contactable_id ? beneficaryData?.contactable_id : "",
        contactable_type:
          beneficaryData?.contactable_type === "vendor"
            ? 1
            : beneficaryData?.contactable_type === "contact"
              ? 2
              : "",
        code: beneficaryData?.code,
        first_name: beneficaryData?.first_name,
        last_name: beneficaryData?.last_name,
        phone: beneficaryData?.phone,
        mobile: beneficaryData?.mobile,
        email: beneficaryData?.email,
        business_name: beneficaryData?.business_name,
        abn: beneficaryData?.abn,
        license_number: beneficaryData?.license_number,

        street: beneficaryData?.street,
        state_id: state,
        suburb_id: beneficaryData?.suburb_id ? beneficaryData?.suburb_id : "",
        postal_code: beneficaryData?.postal_code
          ? beneficaryData?.postal_code.toString()
          : "",

        same_address: false,

        shipping_street: beneficaryData?.shipping_street,
        shipping_state_id: shippingState,
        shipping_suburb_id: beneficaryData?.shipping_suburb_id
          ? beneficaryData?.shipping_suburb_id
          : "",
        shipping_postal_code: beneficaryData?.shipping_postal_code
          ? beneficaryData?.shipping_postal_code.toString()
          : "",

        account_name: beneficaryData?.account_name
          ? beneficaryData?.account_name
          : "",
        bsb: beneficaryData?.bsb ? beneficaryData?.bsb : "",
        account_number: beneficaryData?.account_number
          ? beneficaryData?.account_number
          : "",
        bank_id: projectBank ? projectBank : "",
        opening_balance: beneficaryData?.opening_balance
          ? beneficaryData?.opening_balance
          : 0,
        photo_id: beneficaryData?.kyc?.photo_id
          ? beneficaryData?.kyc?.photo_id
          : "",
        primary_id: beneficaryData?.kyc?.primary_id
          ? beneficaryData?.kyc?.primary_id
          : null,
        secondary_id: beneficaryData?.kyc?.secondary_id
          ? beneficaryData?.kyc?.secondary_id
          : null,
        verification_date: beneficaryData?.kyc?.verification_date
          ? moment(beneficaryData?.kyc?.verification_date, "DD-MM-YYYY")
          : "",
        verified_by: beneficaryData?.kyc?.verified_by
          ? beneficaryData?.kyc?.verified_by
          : "",
        method: beneficaryData?.kyc?.method ? beneficaryData?.kyc?.method : "",
        risk: beneficaryData?.kyc?.risk ? beneficaryData?.kyc?.risk : "",
        cdd: beneficaryData?.kyc?.cdd ? beneficaryData?.kyc?.cdd : "",
        notes: beneficaryData?.kyc?.notes ? beneficaryData?.kyc?.notes : "",
        percentage: beneficaryData?.percentage
          ? beneficaryData?.percentage
          : "0",
      }}
      enableReinitialize={true}
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddBeneficarySchema(organizationData)}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
        setTouched,
        validateField,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-y-auto overflow-x-hidden h-[80vh] p-4 border rounded-lg">
              <div className="grid gap-4">
                <CardTitle className="text-md">Beneficiary Details</CardTitle>
                <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4">
                  {/* <div className="grid md:grid-cols-2 gap-4"> */}
                  {org && (
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="trust_id">
                          <CustomLabelText
                            required={false}
                            labelText="Trust"
                            errorField={errors?.trust_id}
                            bottomAlign={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <TrustSelect
                            orgId={organizationData?.organizationId}
                            frameworkData={trustListing} // List of vendors
                            optionType="Trust"
                            handleBlur={handleBlur}
                            handleSelect={(e) => {
                              setFieldValue("trust_id", e);
                              setFieldValue("contactable_id", "");
                              setFieldValue("contactable_type", "");

                              setVendorListing([]);
                              setVendorList([]);

                              setContactList([]);
                              setContactListing([]);
                            }}
                            name="trust_id"
                            disabled={
                              organizationData?.organizationId ? false : true
                            }
                            initialValue={
                              values?.trust_id ? values?.trust_id : ""
                            }
                            setTrustList={setTrustList} // Update vendor list as new data loads
                            setTrustLoading={setTrustLoading} // Control loading state
                            onClear={() => {
                              setFieldValue("trust_id", "");
                              setFieldValue("contactable_id", "");
                              setFieldValue("contactable_type", "");

                              setVendorListing([]);
                              setVendorList([]);

                              setContactList([]);
                              setContactListing([]);
                            }}
                            loading={trustLoading}
                          />
                          {trustLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="grid gap-2">
                    <Label htmlFor="contactable_type">
                      <CustomLabelText
                        required={true}
                        labelText="Contact Type"
                        errorField={errors?.contactable_type}
                        bottomAlign={true}
                      />
                    </Label>
                    <div className="relative">
                      <SearchSelect
                        frameworks={contactTypeOption}
                        optionType={"Contact Type"}
                        handleSelect={(e) => {
                          setFieldValue("contactable_type", e);
                          setFieldValue("contactable_id", "");
                          setTimeout(() => {
                            setTouched({ contactable_type: true });
                            validateField("contactable_type");
                          }, 0);

                          setTimeout(() => {
                            setTouched({ contactable_id: true });
                            validateField("contactable_id");
                          }, 0);
                        }}
                        handleBlur={handleBlur}
                        className={
                          errors?.base_type &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        disabled={false}
                        initialValue={values?.contactable_type}
                      />
                    </div>
                  </div>

                  {values?.contactable_type === 1 ? (
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="contactable_id">
                          <CustomLabelText
                            labelText={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )}
                            errorField={errors?.contactable_id}
                            required={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <VendorSelect
                            organizationId={
                              organizationData?.organizationId
                                ? organizationData?.organizationId
                                : ""
                            }
                            trustId={values?.trust_id ? values?.trust_id : ""}
                            amlctfContact={values?.trust_id ? false : true}
                            frameworkData={vendorListing} // List of vendors
                            optionType={getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )}
                            handleSelect={(e) => {
                              setFieldValue("contactable_id", e);
                            }}
                            name="contactable_id"
                            disabled={false}
                            initialValue={
                              values?.contactable_id
                                ? values?.contactable_id
                                : ""
                            }
                            setVendorList={setVendorList} // Update vendor list as new data loads
                            setVendorLoading={setVendorLoading} // Control loading state
                            onClear={() => {
                              setFieldValue("contactable_id", "");
                            }}
                            loading={vendorLoading}
                            className={
                              errors?.contactable_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                          {vendorLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : values?.contactable_type === 2 ? (
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="contactable_id">
                          <CustomLabelText
                            labelText={`${getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )}`}
                            errorField={errors?.contactable_id}
                            required={true}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <ContactSelect
                            organizationId={
                              organizationData?.organizationId
                                ? organizationData?.organizationId
                                : ""
                            }
                            trustId={values?.trust_id ? values?.trust_id : ""}
                            amlctfContact={values?.trust_id ? false : true}
                            frameworkData={contactListing} // List of vendors
                            optionType={`${getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )}`}
                            handleSelect={(e) => {
                              setFieldValue(`contactable_id`, e);
                            }}
                            name="contactable_id"
                            disabled={false}
                            initialValue={
                              values?.contactable_id
                                ? values?.contactable_id
                                : ""
                            }
                            setContactList={setContactList} // Update vendor list as new data loads
                            setContactLoading={setContactLoading} // Control loading state
                            onClear={() => {
                              setFieldValue(`contactable_id`, "");
                            }}
                            className={
                              errors?.contactable_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            loading={contactLoading}
                          />
                          {contactLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className="grid gap-2">
                    <Label htmlFor="first_name">
                      <CustomLabelText
                        required={false}
                        labelText="First Name"
                        errorField={errors?.first_name}
                      />
                    </Label>
                    <Input
                      id="first_name"
                      type="text"
                      name="first_name"
                      value={values?.first_name ? values?.first_name : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.first_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  {/* </div> */}
                  {/* <div className="grid md:grid-cols-2 gap-4"> */}
                  <div className="grid gap-2">
                    <Label htmlFor="last_name">
                      <CustomLabelText
                        required={true}
                        labelText="Last Name"
                        errorField={errors?.last_name}
                      />
                    </Label>
                    <Input
                      id="last_name"
                      type="text"
                      name="last_name"
                      value={values?.last_name ? values?.last_name : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.last_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="business_name">
                      <CustomLabelText
                        required={false}
                        labelText="Business Name"
                        errorField={errors?.business_name}
                      />
                    </Label>
                    <Input
                      id="business_name"
                      type="text"
                      name="business_name"
                      value={values?.business_name ? values?.business_name : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.business_name &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  {/* </div> */}
                  {/* <div className="grid md:grid-cols-2 gap-4"> */}
                  <div className="grid gap-2">
                    <Label htmlFor="subContractor_name">
                      <CustomLabelText
                        required={false}
                        labelText="Email"
                        errorField={errors?.email}
                      />
                    </Label>
                    <Input
                      id="email"
                      type="email"
                      placeholder="m@example.com"
                      required
                      autoComplete="off"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.email}
                      className={
                        errors?.email &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="phone">
                      <CustomLabelText
                        required={false}
                        labelText="Phone"
                        errorField={errors?.phone}
                      />
                    </Label>
                    <PhoneInput
                      onChange={(e) => {
                        setFieldValue("phone", e);
                      }}
                      value={values?.phone}
                      defaultValue={"+61"}
                      defaultCountry={"AU"}
                      minLength={15}
                      maxLength={15}
                      onBlur={handleBlur}
                      className={
                        errors?.phone &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  {/* </div> */}
                  {/* <div className="grid md:grid-cols-2 gap-4"> */}
                  <div className="grid gap-2">
                    <Label htmlFor="phone">
                      <CustomLabelText
                        required={false}
                        labelText="Mobile No."
                        errorField={errors?.mobile}
                      />
                    </Label>
                    <PhoneInput
                      onChange={(e) => {
                        setFieldValue("mobile", e);
                      }}
                      value={values?.mobile}
                      defaultValue={"+61"}
                      defaultCountry={"AU"}
                      minLength={15}
                      maxLength={15}
                      onBlur={handleBlur}
                      className={
                        errors?.mobile &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="abn">
                      <CustomLabelText
                        required={false}
                        labelText="ABN"
                        errorField={errors?.abn}
                      />
                    </Label>
                    <ReactInputMask
                      id="abn"
                      type="text"
                      name="abn"
                      value={values?.abn ? values?.abn : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      mask="99 999 999 999"
                      maskChar={null}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.abn
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )
                      }
                    />
                  </div>
                  {/* </div> */}
                  {/* <div className="grid md:grid-cols-2 gap-4"> */}
                  <div className="grid gap-2">
                    <Label htmlFor="license_number">
                      <CustomLabelText
                        required={false}
                        labelText="Licence No."
                        errorField={errors?.license_number}
                      />
                    </Label>
                    <Input
                      id="license_number"
                      type="text"
                      name="license_number"
                      value={
                        values?.license_number ? values?.license_number : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.license_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="code">
                      <CustomLabelText
                        required={false}
                        labelText="Code"
                        errorField={errors?.code}
                      />
                    </Label>
                    <Input
                      id="code"
                      type="text"
                      name="code"
                      value={values?.code ? values?.code : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.code &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="percentage">
                      <CustomLabelText
                        required={false}
                        labelText="Percentage (%)"
                        errorField={errors?.percentage}
                      />
                    </Label>

                    <NumericFormat
                      type="text"
                      name={`percentage`}
                      value={values?.percentage}
                      onChange={handleChange}
                      onBlur={(e) => {
                        setFieldValue(`percentage`, e?.target?.value);
                      }}
                      decimalScale={2}
                      allowNegative={false}
                      thousandSeparator={true}
                      suffix="%"
                      isAllowed={(values) => MaxLimit(values)}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.percentage
                          ? `${cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )} focus-visible:ring-red-500 border-red-500`
                          : cn(
                              "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                            )
                      }
                    />
                  </div>
                  {/* </div> */}
                </div>
              </div>

              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">Address</CardTitle>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="street">
                        <CustomLabelText
                          required={false}
                          labelText="Street Address"
                          errorField={errors?.street}
                        />
                      </Label>
                      <Input
                        id="street"
                        placeholder="Enter Street"
                        required
                        name="street"
                        onChange={(e) => {
                          setFieldValue("street", e?.target?.value);
                          if (isChecked) {
                            setFieldValue("shipping_street", e?.target?.value);
                          }
                        }}
                        onBlur={handleBlur}
                        value={values?.street}
                        className={
                          errors?.street &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="state_id">
                        <CustomLabelText
                          required={false}
                          labelText="State"
                          errorField={errors?.state_id}
                        />
                      </Label>
                      <div className="relative">
                        <SearchSelect
                          frameworks={stateListing}
                          optionType={"State"}
                          clearable={true}
                          onClear={() => {
                            setFieldValue("state_id", "");
                            setFieldValue("suburb_id", "");
                            setSuburbList([]);

                            if (isChecked) {
                              setFieldValue("shipping_state_id", "");
                              setFieldValue("shipping_suburb_id", "");
                              setSuburbShippingList([]);
                            }
                          }}
                          handleSelect={(e) => {
                            setFieldValue("state_id", e);
                            setFieldValue("suburb_id", "");
                            setSuburbList([]);
                            FetchSuburbList(e);
                            if (isChecked) {
                              setFieldValue("shipping_state_id", e);
                              setFieldValue("shipping_suburb_id", "");
                              setSuburbShippingList([]);
                            }
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.state_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.state_id}
                        />
                        {stateLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="suburb_id">
                          <CustomLabelText
                            required={false}
                            labelText="Suburb"
                            errorField={errors?.suburb_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SuburbSelect
                            state_id={values?.state_id}
                            frameworkData={suburbListing}
                            optionType={"Suburb"}
                            loading={suburbLoading}
                            clearable={true}
                            onClear={() => {
                              setFieldValue("suburb_id", "");
                              if (isChecked) {
                                setFieldValue("shipping_suburb_id", "");
                              }
                            }}
                            handleSelect={(e) => {
                              setFieldValue("suburb_id", e);
                              if (isChecked) {
                                setFieldValue("shipping_suburb_id", e);
                              }
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.suburb_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={values?.state_id ? false : true}
                            initialValue={values?.suburb_id}
                            // itemsPerPage={100}
                            setSuburbList={setSuburbList} // Update suburb list as new data loads
                            setSuburbLoading={setSuburbLoading}
                          />
                          {suburbLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="postal_code">
                        <CustomLabelText
                          required={false}
                          labelText="Postal Code"
                          errorField={errors?.postal_code}
                        />
                      </Label>
                      <PostalCodeInput
                        id="postal_code"
                        placeholder="Enter Postal Code"
                        required={true}
                        name="postal_code"
                        handleChange={(e) => {
                          setFieldValue("postal_code", e);
                          if (isChecked) {
                            setFieldValue("shipping_postal_code", e);
                          }
                        }}
                        handleBlur={handleBlur}
                        className="justify-start"
                        inputClassName={
                          errors?.postal_code &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        value={values?.postal_code ? values?.postal_code : ""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr className="hr-content mt-4" />

              <div className="flex items-center space-x-2 mt-4">
                <Checkbox
                  id="terms"
                  checked={isChecked}
                  name="same_address"
                  onClick={() => toggleChecked(values, setFieldValue)}
                  disabled={
                    !values?.street ||
                    !values?.state_id ||
                    !values?.postal_code ||
                    !values?.suburb_id
                  }
                />
                <label
                  htmlFor="terms"
                  className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                >
                  Same as Address
                </label>
              </div>
              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">Street Address</CardTitle>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="shipping_street">
                        <CustomLabelText
                          required={false}
                          labelText="Street Address"
                          errorField={errors?.shipping_street}
                        />
                      </Label>
                      <Input
                        id="shipping_street"
                        placeholder="Enter Street"
                        required
                        name="shipping_street"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values?.shipping_street}
                        disabled={isChecked}
                        className={
                          errors?.shipping_street &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="shipping_state_id">
                        <CustomLabelText
                          required={false}
                          labelText="State"
                          errorField={errors?.shipping_state_id}
                        />
                      </Label>
                      <div className="relative">
                        <SearchSelect
                          frameworks={stateListing}
                          optionType={"State"}
                          clearable={true}
                          onClear={() => {
                            setFieldValue("shipping_state_id", "");
                            setFieldValue("shipping_suburb_id", "");
                            setSuburbShippingList([]);
                          }}
                          handleSelect={(e) => {
                            setFieldValue("shipping_state_id", e);
                            FetchSuburbShippingList(e);
                            setFieldValue("shipping_suburb_id", "");
                            setSuburbShippingList([]);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.shipping_state_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={isChecked}
                          initialValue={values?.shipping_state_id}
                        />
                        {stateLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="shipping_suburb_id">
                          <CustomLabelText
                            required={false}
                            labelText="Suburb"
                            errorField={errors?.shipping_suburb_id}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SuburbSelect
                            state_id={values?.shipping_state_id}
                            frameworkData={suburbShippingListing}
                            loading={suburbLoading}
                            optionType={"Suburb"}
                            clearable={true}
                            onClear={() => {
                              setFieldValue("shipping_suburb_id", "");
                              if (isChecked) {
                                setFieldValue("shipping_suburb_id", "");
                              }
                            }}
                            handleSelect={(e) => {
                              setFieldValue("shipping_suburb_id", e);
                              if (isChecked) {
                                setFieldValue("shipping_suburb_id", e);
                              }
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.shipping_suburb_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={
                              isChecked ||
                              (values?.shipping_state_id ? false : true)
                            }
                            initialValue={values?.shipping_suburb_id}
                            // itemsPerPage={100}
                            setSuburbList={setSuburbShippingList} // Update suburb list as new data loads
                            setSuburbLoading={setSuburbShippingLoading}
                          />
                          {suburbShippingLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="shipping_postal_code">
                        <CustomLabelText
                          required={false}
                          labelText="Postal Code"
                          errorField={errors?.shipping_postal_code}
                        />
                      </Label>
                      <PostalCodeInput
                        id="shipping_postal_code"
                        placeholder="Enter Postal Code"
                        required={true}
                        name="shipping_postal_code"
                        handleChange={(e) => {
                          setFieldValue("shipping_postal_code", e);
                        }}
                        handleBlur={handleBlur}
                        className="justify-start"
                        disabled={isChecked}
                        inputClassName={
                          errors?.shipping_postal_code &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                        value={
                          values?.shipping_postal_code
                            ? values?.shipping_postal_code
                            : ""
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">Bank Account Details</CardTitle>
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="bank_id">
                        <CustomLabelText
                          required={false}
                          labelText="Bank Name"
                          errorField={errors?.bank_id}
                        />
                      </Label>
                      <div className="relative">
                        <SearchSelect
                          frameworks={bankListing}
                          optionType={"Bank"}
                          handleSelect={(e) => {
                            setFieldValue("bank_id", e);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.bank_id &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.bank_id}
                        />
                        {bankLoading && (
                          <span className="absolute top-2 right-2 animate-spin">
                            <Loader2 width={20} height={20} />
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="grid gap-2">
                      <Label htmlFor="account_name">
                        <CustomLabelText
                          required={false}
                          labelText="Bank Account Name"
                          errorField={errors?.account_name}
                        />
                      </Label>
                      <Input
                        type="text"
                        name="account_name"
                        value={values?.account_name ? values?.account_name : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.account_name &&
                          `focus-visible:ring-red-500 border-red-500`
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="bsb">
                        <CustomLabelText
                          required={false}
                          labelText="BSB"
                          errorField={errors?.bsb}
                        />
                      </Label>
                      <ReactInputMask
                        id="bsb"
                        type="text"
                        name="bsb"
                        value={values?.bsb ? values?.bsb : ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        mask="999-999"
                        maskChar={null}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.bsb
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )
                        }
                      />
                    </div>
                    <div className="grid gap-2">
                      <Label htmlFor="account_number">
                        <CustomLabelText
                          required={false}
                          labelText="Account Number"
                          errorField={errors?.account_number}
                        />
                      </Label>
                      <ReactInputMask
                        id="account_number"
                        type="text"
                        name="account_number"
                        value={
                          values?.account_number ? values?.account_number : ""
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        mask="999999999"
                        maskChar={null}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.account_number
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )
                        }
                      />
                    </div>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4 items-baseline">
                    <div className="grid gap-2">
                      <Label htmlFor="opening_balance">
                        <CustomLabelText
                          required={false}
                          labelText="Opening Balance($)"
                          errorField={errors?.opening_balance}
                        />
                      </Label>

                      <NumericFormat
                        type="text"
                        name="opening_balance"
                        value={values?.opening_balance}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        decimalScale={2}
                        allowNegative={false}
                        thousandSeparator={true}
                        isAllowed={(values) => MaxLimit(values)}
                        autoComplete="off"
                        onKeyPress={(e) => {
                          e.which === 13 && e.preventDefault();
                        }}
                        className={
                          errors?.opening_balance
                            ? `${cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )} focus-visible:ring-red-500 border-red-500`
                            : cn(
                                "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                              )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid gap-4 pt-4">
                <CardTitle className="text-md">
                  {" "}
                  Proof of ID for Customer Due Diligence (CDD)
                </CardTitle>
                <div className="grid xl:grid-cols-2 grid-cols-1 gap-4">
                  <div className="grid md:grid-cols-4 gap-4">
                    <div className="grid md:grid-cols-1 gap-4 md:col-span-1 col-span-3">
                      <ProfileUpload
                        path={values?.photo_id}
                        // pathData={values?.photo_id?.charAt(0)}
                        setFieldValue={setFieldValue}
                        keyName={"photo_id"}
                      />
                    </div>
                    <div className="grid md:grid-cols-2 gap-4 col-span-3">
                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="primary_id">
                            <CustomLabelText
                              labelText="Primary ID"
                              errorField={errors?.primary_id}
                              className="mb-2"
                            />
                          </Label>

                          <Dropzone
                            accept={{ "image/*": [] }}
                            onDrop={(acceptedFiles) => {
                              if (acceptedFiles.length > 0)
                                setPrimaryID([acceptedFiles[0]]);
                              setFieldValue("primary_id", acceptedFiles[0]);
                            }}
                            multiple={false}
                          >
                            {({ getRootProps, getInputProps }) =>
                              primaryID.length === 0 &&
                              typeof values.primary_id !== "string" ? (
                                <div
                                  {...getRootProps()}
                                  className="cursor-pointer border border-dashed p-4 rounded-md text-center text-sm"
                                >
                                  <input {...getInputProps()} />+ Upload
                                </div>
                              ) : (
                                <div className="flex items-center justify-between w-full cursor-pointer border border-dashed p-4 rounded-md text-center text-sm">
                                  <div className="flex items-center gap-2">
                                    <FileIcon className="h-4 w-4 text-muted-foreground" />
                                    <span className="truncate max-w-[160px] whitespace-nowrap overflow-hidden">
                                      {typeof values?.primary_id === "string"
                                        ? getFileNameFromUrl(values?.primary_id)
                                        : primaryID[0]?.name}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    {typeof values?.primary_id === "string" && (
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownload(values?.primary_id);
                                        }}
                                        className="ml-2 text-sm text-green-500 hover:underline"
                                      >
                                        <Download size={16} />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setPrimaryID([]);
                                        setFieldValue("primary_id", null);
                                      }}
                                      className="ml-2 text-sm text-red-500 hover:underline"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              )
                            }
                          </Dropzone>
                        </div>
                      </div>

                      {/* Secondary ID */}
                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="secondary_id">
                            <CustomLabelText
                              labelText="Secondary ID"
                              errorField={errors?.secondary_id}
                              className="mb-2"
                            />
                          </Label>
                          <Dropzone
                            accept={{ "image/*": [] }}
                            onDrop={(acceptedFiles) => {
                              if (acceptedFiles.length > 0)
                                setSecondaryID([acceptedFiles[0]]);
                              setFieldValue("secondary_id", acceptedFiles[0]);
                            }}
                            multiple={false}
                          >
                            {({ getRootProps, getInputProps }) =>
                              secondaryID.length === 0 &&
                              typeof values.secondary_id !== "string" ? (
                                <div
                                  {...getRootProps()}
                                  className="cursor-pointer border border-dashed p-4 rounded-md text-center text-sm"
                                >
                                  <input {...getInputProps()} />+ Upload
                                </div>
                              ) : (
                                <div className="flex items-center justify-between w-full cursor-pointer border border-dashed p-4 rounded-md text-center text-sm">
                                  <div className="flex items-center gap-2">
                                    <FileIcon className="h-4 w-4 text-muted-foreground" />
                                    <span className="truncate max-w-[160px] whitespace-nowrap overflow-hidden">
                                      {typeof values.secondary_id === "string"
                                        ? getFileNameFromUrl(
                                            values.secondary_id,
                                          )
                                        : secondaryID[0]?.name}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    {typeof values?.secondary_id ===
                                      "string" && (
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownload(values?.secondary_id);
                                        }}
                                        className="ml-2 text-sm text-green-500 hover:underline"
                                      >
                                        <Download size={16} />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSecondaryID([]);
                                        setFieldValue("secondary_id", null);
                                      }}
                                      className="ml-2 text-sm text-red-500 hover:underline"
                                    >
                                      ✕
                                    </button>
                                  </div>
                                </div>
                              )
                            }
                          </Dropzone>
                        </div>
                      </div>
                      <p className="text-xs text-center text-muted-foreground col-span-2">
                        We do not recommend retaining ID docs
                      </p>
                    </div>
                  </div>

                  {/* Verification Info */}
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="verification_date">
                          <CustomLabelText
                            labelText="Verification Date"
                            errorField={errors?.verification_date}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <DateInputPicker
                            date={
                              values?.verification_date
                                ? values?.verification_date
                                : ""
                            }
                            onSelect={(e) => {
                              setFieldValue("verification_date", e);
                            }}
                            inputClassName="w-full"
                            className={""}
                            disabledDate={{ after: new Date() }}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Verified By */}
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="verified_by">
                          <CustomLabelText
                            labelText="Verified By"
                            errorField={errors?.verified_by}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <UserSelect
                            orgId={organizationData?.organizationId}
                            frameworkData={userListing} // List of vendors
                            optionType="User"
                            handleSelect={(e) => {
                              setFieldValue(`verified_by`, e);
                            }}
                            name="verified_by"
                            disabled={false}
                            initialValue={
                              values?.verified_by ? values?.verified_by : ""
                            }
                            setUserList={setUserList}
                            setUserLoading={setUserLoading}
                            onClear={() => {
                              setFieldValue(`verified_by`, "");
                            }}
                            className={
                              errors?.verified_by &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            loading={userLoading}
                          />
                          {userLoading && (
                            <span className="absolute top-2 right-2 animate-spin">
                              <Loader2 width={20} height={20} />
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* Verification Method */}
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="method">
                          <CustomLabelText
                            labelText="Method"
                            errorField={errors?.method}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={verificationMethods}
                            optionType={"Method"}
                            handleSelect={(e) => {
                              setFieldValue("method", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.method &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.method}
                          />
                        </div>
                      </div>
                    </div>
                    {/* CDD */}
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="cdd">
                          <CustomLabelText
                            labelText="CDD Type"
                            errorField={errors?.cdd}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={cddOptions}
                            optionType={"CDD Type"}
                            handleSelect={(e) => {
                              setFieldValue("cdd", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.cdd &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.cdd}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Risk Profile */}
                    <div className="grid gap-2">
                      <div className="min-w-0">
                        <Label htmlFor="risk">
                          <CustomLabelText
                            labelText="Risk Profile"
                            errorField={errors?.risk}
                          />
                        </Label>
                        <div className="relative mt-2">
                          <SearchSelect
                            frameworks={riskProfile}
                            optionType={"Risk Profile"}
                            handleSelect={(e) => {
                              setFieldValue("risk", e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.risk &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                            initialValue={values?.risk}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Note */}
                  <div className="grid md:grid-cols-1 gap-4">
                    <div className="grid gap-2">
                      <Label htmlFor="notes">
                        <CustomLabelText
                          labelText="Note"
                          errorField={errors?.notes}
                        />
                      </Label>
                      <Textarea
                        name="notes"
                        rows={4}
                        placeholder="How did you verify Individual's Full Name AND Either Residential Address OR DOB? Or add reasoning/notes."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.notes}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditBeneficary();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default AddEditBeneficary;
